import type { AppErrorRenderer } from './appErrorRenderer';

const loadAppErrorRenderer = async (): Promise<AppErrorRenderer> => {
  const renderer = await import(
    /* webpackChunkName: "3-render-apperrorrenderer" */ 'bootstrap/entries/3-render/appErrorRenderer'
  );

  return renderer.default;
};

export default loadAppErrorRenderer;
